/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Figure_BackInputs */

const en_us2_bodymap_figure_back = /** @type {(inputs: Bodymap_Figure_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

const pt_br2_bodymap_figure_back = /** @type {(inputs: Bodymap_Figure_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costas`)
};

const es_419_bodymap_figure_back = /** @type {(inputs: Bodymap_Figure_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espalda`)
};

const pt_pt2_bodymap_figure_back = /** @type {(inputs: Bodymap_Figure_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costas`)
};

const fr_fr2_bodymap_figure_back = /** @type {(inputs: Bodymap_Figure_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dos`)
};

const de_de2_bodymap_figure_back = /** @type {(inputs: Bodymap_Figure_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rücken`)
};

const it_it2_bodymap_figure_back = /** @type {(inputs: Bodymap_Figure_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retro`)
};

/**
* | output |
* | --- |
* | "Back" |
*
* @param {Bodymap_Figure_BackInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_figure_back = /** @type {((inputs?: Bodymap_Figure_BackInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Figure_BackInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_figure_back(inputs)
	if (locale === "es-419") return es_419_bodymap_figure_back(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_figure_back(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_figure_back(inputs)
	if (locale === "de-DE") return de_de2_bodymap_figure_back(inputs)
	if (locale === "it-IT") return it_it2_bodymap_figure_back(inputs)
	return en_us2_bodymap_figure_back(inputs)
});
export { bodymap_figure_back as "bodymap.figure.back" }